import React, { Component } from 'react';

import Home from './Home'
import About from './About'
import Timeline from './Timeline'
import Projects from './/Projects'
import Interests from './Interests'
import Skills from './Skills'
// import Quotes from './Quotes'
import {Contact} from './Contact'
import 'bulma'

class App extends Component {
	render() {
		return (
			<div className="App">
				<Home/>
				<About/>
				<Timeline/>
				<Projects/>
				<Interests/>
				<Skills/>
				{/* <Quotes/> */}
				<Contact/>
			</div>
		);
	}
}

export default App;
